export default __webpack_public_path__ + "static/media/tagbilaran.2756cec8.jpg";